import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

const StyledHeader = styled('div', {
    shouldForwardProp: (prop) => prop === 'children',
}) `
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  padding-right: 8px;
  border-top: ${({ hasBorderTop }) => (hasBorderTop ? '1px solid #344152' : 'none')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
  opacity: ${({ reduceOpacity }) => (reduceOpacity ? '0.5' : '1')};
`;
const Header = ({ hasBorderTop, disabled, reduceOpacity, children }) => (jsx(StyledHeader, Object.assign({ hasBorderTop: hasBorderTop, disabled: disabled, reduceOpacity: reduceOpacity }, { children: children })));

export { Header };
//# sourceMappingURL=Header.js.map
